// Shared (localStorage-backed) tracking of which order alerts have been seen / acknowledged.
const SEEN = "bbs_alert_seen";
const ACK = "bbs_alert_ack";

function load(key) {
  try { return new Set(JSON.parse(localStorage.getItem(key) || "[]")); }
  catch { return new Set(); }
}
function save(key, set) {
  // keep it bounded to the most recent 500 ids
  const arr = [...set].slice(-500);
  localStorage.setItem(key, JSON.stringify(arr));
}

export const getSeen = () => load(SEEN);
export const getAck = () => load(ACK);
export const isSeen = (id) => load(SEEN).has(id);
export const isAck = (id) => load(ACK).has(id);

export function markSeen(ids) {
  const s = load(SEEN);
  ids.forEach((i) => s.add(i));
  save(SEEN, s);
}

export function markAck(ids) {
  const s = load(ACK);
  ids.forEach((i) => s.add(i));
  save(ACK, s);
  window.dispatchEvent(new Event("bbs-alert-ack"));
}
